import {
  AutoFillFormTypeEnum,
  BrandingColorsToolResult,
  BrandingCustomCssToolResult,
  GeneratedImageToolResult,
  SetupGuideAiModeEnum,
} from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.models'

export enum SetupGuideAiMessageTypeEnum {
  User = 'user',
  Assistant = 'assistant',
  ToolCall = 'tool_call',
  ToolResult = 'tool_result',
  Error = 'error',
}

export type SetupGuideAiMessageType = SetupGuideAiMessageTypeEnum
export type SetupGuideAiMessageSide = 'left' | 'right'
export type ToolDisplayType = 'colors' | 'css' | 'articles' | 'article-content' | 'image' | 'key-value'

export interface ToolConfig {
  labelKey: string
  generatingKey: string
  resultKey: string
  displayType: ToolDisplayType
  dashboardPage: string
}

export interface ArticleSearchResultEntry {
  score: number
  title: string
  topic: string
  url: string
  last_updated: string
}

export interface ArticleContentResult {
  title: string
  url: string
  content: string
  last_updated: string
  topic: string
}

export interface SetupGuideAiMessage {
  id: string
  type: SetupGuideAiMessageType
  side: SetupGuideAiMessageSide
  content: string
  toolName?: string
  callId?: string
  toolArguments?: string
  toolContent?:
    | BrandingColorsToolResult
    | BrandingCustomCssToolResult
    | GeneratedImageToolResult
    | Record<string, unknown>
  showLoadingDots?: boolean
  createdAt: string
}

export interface BrandingColorPreviewEntry {
  key: keyof BrandingColorsToolResult
  label: string
  value: string
}

export interface SetupGuideAiChatSession {
  id: string
  title: string
  formType: AutoFillFormTypeEnum | null | undefined
  aiMode: SetupGuideAiModeEnum
  auctionUrlName: string
  createdAt: string
  updatedAt: string
  messages: SetupGuideAiMessage[]
}
